import { fetchProfile, UserProfile } from "./components/Authentication";
//import { MockedProjectsService } from "./mocks/ApiService";
import { APIResource, unpaginate } from "./useResource";
import {
  Environment,
  EnvironmentConfigVar,
  Project,
  ProjectsService,
  Service,
  ServiceConfigVar,
} from "./_generated";

/////////////////////////////////////////////////////
//// Only for testing purposes, remove later ////////
//let url = new URL(window.location.href);
//const useMocks = url.searchParams.get("useMocks");
////////////////////////////////////////////////////

const api = ProjectsService;

//process.env.REACT_APP_USE_MOCKED_API || useMocks !== null
//    ? (MockedProjectsService as typeof ProjectsService)
//    : ProjectsService;

// All APIs are registered here
const API = {
  profile: new APIResource({} as UserProfile, {
    keyProp: "pk",
    read: {
      fn: fetchProfile,
      cacheKey: () => [],
    },
  }),
  projects: new APIResource({} as Project, {
    keyProp: "name",
    read: {
      fn: api.projectsRead,
      cacheKey: (projectName) => [projectName],
    },
    list: {
      fn: unpaginate(api.projectsList),
      cacheKey: () => [],
    },
    create: {
      // TODO: change once the API is available
      fn: api.projectsCreate,
      cacheKey: () => [],
    },
  }),
  services: new APIResource({} as Service, {
    keyProp: "pk",
    read: {
      fn: api.projectsServicesRead,
      cacheKey: (id, projectName) => [projectName, String(id)],
    },
    list: {
      fn: unpaginate(api.projectsServicesList),
      cacheKey: (projectName) => [projectName],
    },
    create: {
      fn: api.projectsServicesCreate,
      cacheKey: (projectName) => [projectName],
    },
    update: {
      fn: api.projectsServicesUpdate,
      cacheKey: (id, projectName) => [projectName, String(id)],
    },
    delete: {
      fn: api.projectsServicesDelete,
      cacheKey: (id, projectName) => [projectName, String(id)],
    },
  }),
  serviceConfigVars: new APIResource({} as ServiceConfigVar, {
    keyProp: "pk",
    read: {
      fn: api.projectsServicesConfigsRead,
      cacheKey: (id, projectName, servicePk) => [
        projectName,
        servicePk,
        String(id),
      ],
    },
    list: {
      fn: unpaginate(api.projectsServicesConfigsList),
      cacheKey: (projectName, servicePk) => [projectName, servicePk],
    },
    create: {
      fn: api.projectsServicesConfigsCreate,
      cacheKey: (projectName, servicePk) => [projectName, servicePk],
    },
    update: {
      fn: api.projectsServicesConfigsUpdate,
      cacheKey: (id, projectName, servicePk) => [
        projectName,
        servicePk,
        String(id),
      ],
    },
    delete: {
      fn: api.projectsServicesConfigsDelete,
      cacheKey: (id, projectName, servicePk) => [
        projectName,
        servicePk,
        String(id),
      ],
    },
  }),
  environments: new APIResource({} as Environment, {
    keyProp: "pk",
    read: {
      fn: api.projectsEnvironmentsRead,
      cacheKey: (id, projectName) => [projectName, String(id)],
    },
    list: {
      fn: unpaginate(api.projectsEnvironmentsList),
      cacheKey: (projectName) => [projectName],
    },
    create: {
      fn: api.projectsEnvironmentsCreate,
      cacheKey: (projectName) => [projectName],
    },
    update: {
      fn: api.projectsEnvironmentsUpdate,
      cacheKey: (id, projectName) => [projectName, String(id)],
    },
    delete: {
      fn: api.projectsEnvironmentsDelete,
      cacheKey: (id, projectName) => [projectName, String(id)],
    },
  }),
  environmentConfigVars: new APIResource({} as EnvironmentConfigVar, {
    keyProp: "pk",
    read: {
      fn: api.projectsEnvironmentsConfigsRead,
      cacheKey: (environmentPk, id, projectName) => [
        projectName,
        environmentPk,
        String(id),
      ],
    },
    list: {
      fn: unpaginate(api.projectsEnvironmentsConfigsList),
      cacheKey: (environmentPk, projectName) => [projectName, environmentPk],
    },
    create: {
      fn: api.projectsEnvironmentsConfigsCreate,
      cacheKey: (environmentPk, projectName) => [projectName, environmentPk],
    },
    update: {
      fn: api.projectsEnvironmentsConfigsUpdate,
      cacheKey: (environmentPk, id, projectName) => [
        projectName,
        environmentPk,
        String(id),
      ],
    },
    delete: {
      fn: api.projectsEnvironmentsConfigsDelete,
      cacheKey: (environmentPk, id, projectName) => [
        projectName,
        environmentPk,
        String(id),
      ],
    },
  }),
};

export default API;
